class PPModeCards extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-mode-card]'));
    this.desktop = window.matchMedia('(min-width: 1200px)');

    if (!this.cards.length) return;

    const requestedIndex = Number.parseInt(this.dataset.initialCard, 10) - 1;
    const initialIndex = Number.isNaN(requestedIndex)
      ? 0
      : Math.min(Math.max(requestedIndex, 0), this.cards.length - 1);

    this.activeCard = this.cards[initialIndex];

    this.cards.forEach((card) => {
      card.addEventListener('click', this.handleClick);
      card.addEventListener('focus', this.handleFocus);
      card.addEventListener('keydown', this.handleKeydown);
    });

    this.desktop.addEventListener('change', this.syncLayoutMode);
    document.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.syncLayoutMode();
    this.classList.add('is-ready');
  }

  disconnectedCallback() {
    this.cards?.forEach((card) => {
      card.removeEventListener('click', this.handleClick);
      card.removeEventListener('focus', this.handleFocus);
      card.removeEventListener('keydown', this.handleKeydown);
    });

    this.desktop?.removeEventListener('change', this.syncLayoutMode);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  activate(card) {
    if (!this.desktop.matches || !card || card === this.activeCard) return;

    this.activeCard = card;
    this.syncLayoutMode();
  }

  syncLayoutMode = () => {
    const isDesktop = this.desktop.matches;

    this.cards.forEach((card) => {
      const isExpanded = !isDesktop || card === this.activeCard;
      card.classList.toggle('is-active', isExpanded);

      if (isDesktop) {
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-expanded', String(isExpanded));
      } else {
        card.setAttribute('role', 'group');
        card.setAttribute('tabindex', '-1');
        card.removeAttribute('aria-expanded');
      }
    });
  };

  handleClick = (event) => {
    this.activate(event.currentTarget);
  };

  handleFocus = (event) => {
    this.activate(event.currentTarget);
  };

  handleKeydown = (event) => {
    if (!this.desktop.matches) return;

    const card = event.currentTarget;
    const index = this.cards.indexOf(card);

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.activate(card);
      return;
    }

    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (index + direction + this.cards.length) % this.cards.length;
    this.cards[nextIndex].focus();
  };

  handleBlockSelect = (event) => {
    const card = event.target?.closest?.('[data-mode-card]');
    if (!card || !this.contains(card)) return;

    this.activeCard = card;
    this.syncLayoutMode();
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    card.scrollIntoView({ behavior, block: 'nearest', inline: 'nearest' });
  };
}

if (!customElements.get('pp-mode-cards')) {
  customElements.define('pp-mode-cards', PPModeCards);
}
